module.exports = {
    module_name: 'lms',
    api: "lms",
    source: "kizan_solutions_lms"
};
